import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import './Testimonials.css';

const testimonials = [
  {
    id: 1,
    name: "Pachpande",
    role: "Mathura & Vrindavan Tour",
    text: "Our 4th trip with Chandrama Holidays (Mathura-Agra) was exceptional. Vedant and Shrushti treated us like family, ensuring everything from food to sightseeing was perfect. Their dedication to customer satisfaction is truly commendable!",
    rating: 5
  },
  {
    id: 2,
    name: "Jaymala",
    role: "GIRNAR TRIP",
    text: "Dear Chandrama Holiday Team, Thank you very much for the wonderful trip to Girnar. This was truly an unforgettable experience. From the captivating scenery to the delicious food, every moment was filled with joy and laughter. The trip was perfectly planned, and I appreciate all the effort you put into making it so special.",
    rating: 5
  },
  {
    id: 3,
    name: "Jyoti Bhagandiya",
    role: "GIRNAR TRIP",
    text: "Chandrama Holidays, Thanks for making our Girnar trip so easy n unforgettable which was very difficult in our thought. Perfect management Best hotels n restaurants. Everything give us home touch. Dwarka dershan was so wonderful. Always with Chandrama Holidays.",
    rating: 5
  },
  {
    id: 4,
    name: "Dilip Pote",
    role: "KERALA TRIP",
    text: "Wonderful and well arranged tour from Chandrama holidays. I really had an amazing experience traveling in Kerala for around 12 days. Everything was well planned which made us enjoy the entire trip. Not only the stay and spots, but the food and safety were also taken care properly. Indeed this was and will always be memorable trip.",
    rating: 5
  },
  {
    id: 5,
    name: "Bhakti Deshmukh",
    role: "SPITI VALLEY, HIMACHAL PRADESH",
    text: "My recent trip to Spiti Valley with Chandrama Holidays was truly unforgettable. From the stay, food, and travel arrangements everything was absolutely fantastic. A special thanks to Raju Sarkale and Vedant Sarkale who handled everything so calmly and efficiently. It honestly felt like travelling with an extended family.",
    rating: 5
  },
  {
    id: 6,
    name: "Vimal Galani",
    role: "KORIGAD TREK",
    text: "Had a great experience at Koraigad Trek. Enjoyed a lot! Thanks to the Chandrama Holidays, everything was properly organised..",
    rating: 5
  },
  {
    id: 7,
    name: "Sharmila Tendulkar",
    role: "VRINDAVAN- MATHURA",
    text: "We had a wonderful experience with the tour company Chandrama Holiday's and tour guides Shrushti and Vedant during our trip to Vrindavan, Barsana, Mathura and Agra. The entire journey was well-organized, comfortable and thoughtfully planned, making it a truly memorable experience. The Vrindavan portion was spiritually enriching, mandirs were covered efficiently, and Agra was equally impressive. Transportation was punctual and the driver was polite. Overall excellent coordination.",
    rating: 5
  },
  {
    id: 8,
    name: "Yashomati Bhairat",
    role: "VRINDAVAN- MATHURA",
    text: "I did one short trip to Meher retreat around Pune and the other one to Goa with Chandrama holidays. They offer one of the best travel services. Raju Sir and Srushti Sarkale made sure everyone was in good health. As I was travelling with my toddler, they made sure she was looked after, which made me feel secured. Highly recommend their reliable and hassle-free service.",
    rating: 5
  }
];

// Individual Card Component
const TestimonialCard = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const limit = 140;

  return (
    <div className={`premium-card ${isExpanded ? 'expanded' : ''}`}>
      
      <div className="quote-icon-box">
        <FaQuoteLeft />
      </div>

      <div className="rating-box">
        {[...Array(item.rating)].map((_, i) => (
          <FaStar key={i} />
        ))}
      </div>

      <div className="scroll-content">
        <p className="testi-para">
          {isExpanded
            ? item.text
            : `${item.text.substring(0, limit)}${
                item.text.length > limit ? '...' : ''
              }`}
        </p>

        {item.text.length > limit && (
          <button
            className="read-more-btn"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'Show Less' : 'Read More'}
          </button>
        )}
      </div>

      {/* USER DETAILS WITHOUT IMAGE */}
      <div className="user-profile-premium no-image-profile">
        <div className="user-details">
          <h4>{item.name}</h4>
          <span>{item.role}</span>
        </div>
      </div>

    </div>
  );
};

const Testimonials = () => {
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <section className="testimonial-section">

      <div className="testi-header">
        
        <motion.span
          className="testi-badge"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          REVIEWS
        </motion.span>

        <motion.h2
          className="testi-title"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
        >
          What Our <span>Happy Travelers</span> Say
        </motion.h2>

        <motion.div
          className="heading-line"
          initial={{ width: 0 }}
          whileInView={{ width: "80px" }}
        ></motion.div>

      </div>

      <div className="marquee-container">

        <motion.div
          className="marquee-content"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            ease: "linear",
            duration: 45,
            repeat: Infinity
          }}
          whileHover={{ animationPlayState: "paused" }}
        >

          {duplicatedTestimonials.map((item, index) => (
            <TestimonialCard key={index} item={item} />
          ))}

        </motion.div>

      </div>

    </section>
  );
};

export default Testimonials;